import * as Types from '../../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type SelectAddonMutationVariables = Types.Exact<{
	addonShortName?: Types.InputMaybe<Types.Scalars['String']['input']>;
	addonShortNames?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
	state: Types.Scalars['Boolean']['input'];
	country: Types.Scalars['Country']['input'];
	platform?: Types.Platform;
}>;

export type SelectAddonMutation = {
	__typename?: 'Mutation';
	setPackage: {
		__typename?: 'UpdateSettingsPayload';
		packages: Array<{
			__typename?: 'Package';
			id: string;
			selected: boolean;
			addons: Array<{ __typename?: 'Package'; id: string; selected: boolean }>;
		}>;
	};
};

export const SelectAddonDocument = gql`
	mutation SelectAddon(
		$addonShortName: String
		$addonShortNames: [String!]
		$state: Boolean!
		$country: Country!
		$platform: Platform! = WEB
	) {
		setPackage(
			input: {
				state: $state
				packages: $addonShortNames
				package: $addonShortName
				country: $country
				platform: $platform
			}
		) {
			packages(country: $country, platform: $platform) {
				id
				selected
				addons(platform: $platform, country: $country) {
					id
					selected
				}
			}
		}
	}
`;
